import { html } from "lit";
var icon_minimize_default = () => html`
  <svg stroke-fill viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)" stroke-width="1.13" stroke-linecap="round" stroke-linejoin="round">
      <path d="m17.44.56-6.75 6.75" />
      <path d="M7.31 15.75v-5.06H2.25" />
      <path d="M10.69 2.25V7.3h5.06" />
      <path d="M7.31 10.69.56 17.44" />
    </g>
    <defs>
      <clipPath id="a"><path d="M0 0h18v18H0z" /></clipPath>
    </defs>
  </svg>
`;
export {
  icon_minimize_default as default
};
//# sourceMappingURL=icon-minimize.js.map
